export enum enSearchParams {
  termProductBumps = 'term_bump',
  termProductMain = 'term_main'
}
